import { Injectable, signal, inject } from '@angular/core';
import { LandingpageConfiguration } from 'app/shared/models/landingpage-configuration.model';
import { lastValueFrom } from 'rxjs';
import { BackendService } from '../backend.service';
import { AuthenticationStateService } from './authentication-state.service';

@Injectable({
  providedIn: 'root',
})
export class LandingpageConfigurationStateService {
  private authenticationStateService = inject(AuthenticationStateService);
  private backendService = inject(BackendService);

  private readonly landingpageConfigurationSignal = signal<LandingpageConfiguration | null>(null);

  readonly landingpageConfiguration = this.landingpageConfigurationSignal.asReadonly();

  setLandingpageConfiguration(value: LandingpageConfiguration) {
    this.landingpageConfigurationSignal.set(value);
  }

  hasLandingpageConfiguration(): boolean {
    return !!this.landingpageConfigurationSignal();
  }

  async fetchLandingpageConfigurationForToken(personalAccessToken: string): Promise<void> {
    const response = await lastValueFrom(this.backendService.submitPersonalAccessToken(personalAccessToken));
    this.authenticationStateService.setPersonalAccessToken(personalAccessToken);
    this.setLandingpageConfiguration(response);
  }

  async fetchLandingpageConfiguration(): Promise<void> {
    await this.fetchLandingpageConfigurationForToken(this.authenticationStateService.personalAccessToken()!);
  }
}
